import React from "react";
import Button from "../../components/EmptyButton";
import claraImage from "../../assets/images/clara-ai.jpg";
import { FaBrain, FaClock, FaRobot } from "react-icons/fa";
import { IoIosTrendingUp } from "react-icons/io";
import { FiMessageSquare, FiZap } from "react-icons/fi";

const AISection = () => {
  const features = [
    {
      icon: FaClock,
      title: "24/7 Availability",
      description: "Get help anytime, anywhere",
    },
    {
      icon: FaBrain,
      title: "Personalized Learning",
      description: "Adapts to your learning style",
    },
    {
      icon: IoIosTrendingUp,
      title: "Progress Tracking",
      description: "Monitor your academic growth",
    },
    {
      icon: FiMessageSquare,
      title: "Interactive Support",
      description: "Conversational AI assistance",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-background via-secondary/30 to-background">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div
                className="text-primary border rounded-xl flex items-center w-fit px-2 py-1 w-48"
                style={{ backgroundColor: "#ffe2cf" }}
              >
                <FaRobot className="w-4 h-4 mr-2" />
                Coming Soon
              </div>

              <h2
                className="text-foreground"
                style={{ fontSize: "3rem", fontWeight: "700", lineHeight: "1" }}
              >
                Meet Clara,
                <span className="block text-primary">
                  Your AI Study
                  <br /> Companion
                </span>
              </h2>
              <p
                className="text-muted-foreground leading-relaxed"
                style={{
                  color: "#78726d",
                  lineHeight: "1.625",
                  fontSize: "1.25rem",
                }}
              >
                We are soon launching Clara, your AI tutor and career mentor
                designed to help you excel academically and professionally with
                24/7 personalized assistance.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-3 p-4 bg-white rounded-lg border"
                  style={{ borderColor: "#f7f7f7" }}
                >
                  <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <feature.icon
                      className="text-white"
                      style={{ fontSize: "1.5rem" }}
                    />
                  </div>

                  <div>
                    <h3
                      className="font-bold text-foreground text-sm"
                      style={{ fontSize: "0.875rem" }}
                    >
                      {feature.title}
                    </h3>
                    <p
                      className="text-xs text-muted-foreground"
                      style={{ fontSize: "0.75rem", color: "#78726d" }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="space-y-4">
              <h3
                className="font-bold text-foreground"
                style={{ fontSize: "1.125rem", fontWeight: "600" }}
              >
                Clara will help you:
              </h3>
              <ul className="space-y-2">
                {[
                  "Get instant answers to academic questions",
                  "Create personalized study plans",
                  "Practice with interactive exercises",
                  "Receive career guidance and advice",
                  "Track your learning progress",
                ].map((item, index) => (
                  <li key={index} className="flex items-center space-x-3">
                    <FiZap className="w-5 h-5 text-primary flex-shrink-0" />
                    <span
                      className="text-muted-foreground"
                      style={{ color: "#78726d" }}
                    >
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="w-72">
              <Button
                filled={true}
                className="text-lg px-8 py-2"
                onClick={() =>
                  window.open("https://studycrowd.ai/login", "_blank")
                }
              >
                Sign Up
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="overflow-hidden shadow-floating border-border/50 bg-gradient-card">
              <div className="p-8 bg-white">
                <div className="text-center space-y-6">
                  <div className="relative inline-block">
                    <img
                      src={claraImage}
                      alt="Clara AI Assistant"
                      className="w-48 h-48 object-cover rounded-2xl mx-auto"
                    />
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-green-500 rounded-full border-2 border-card animate-pulse"></div>
                  </div>
                  <div>
                    <h3 className="font-bold text-foreground" style={{fontSize: '1.5rem', fontWeight: '700'}}>
                      Clara
                    </h3>
                    <p className="text-muted-foreground" style={{color: '#78726d'}}>
                      AI Study & Career Assistant
                    </p>
                  </div>
                  <div className="rounded-lg p-4 text-left" style={{backgroundColor: '#f5f2f080'}}>
                    <p className="text-sm text-foreground italic">
                      "Hi! I'm Clara, your personal AI tutor. I'm here to help
                      you succeed in your studies and build an amazing career.
                      Let's achieve your goals together!"
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISection;
